export const MIN_SALARY = 20000;
export const MAX_SALARY = 300000;

export const SALARY_OPTIONS = [
	{ title: 'Any salary', id: 1, value: null, isDefault: true },
	{ title: '$50,000+/yr', id: 2, value: 50000 },
	{ title: '$80,000+/yr', id: 3, value: 80000 },
	{ title: '$120,000+/yr', id: 4, value: 120000 },
	{ title: '$170,000+/yr', id: 5, value: 170000 },
	{ title: '$220,000+/yr', id: 6, value: 220000 },
];
